import { Flag, Swords, Trophy } from "lucide-react";
import { styles } from "../styles";
import { OptionCard } from "../common/OptionCard";
import { Clubhouse_LeagueScoring } from "../../enums";
import { useFormContext, Controller } from "react-hook-form";
import type { LeagueFormValues } from "../leagueFormSchema";

/**
 * Scramble never reaches this step — a shared-ball format only scores as
 * Stroke Play, so the wizard drops the step and sets the value itself.
 */
export function LeagueScoringStep() {
  const {
    control,
    formState: { errors },
  } = useFormContext<LeagueFormValues>();

  return (
    <div className="flex flex-col items-center gap-3">
      <Controller
        name="wizard.leagueScoringType"
        control={control}
        render={({ field }) => (
          <div className="grid w-full grid-cols-1 gap-3 sm:grid-cols-3">
            <OptionCard
              icon={<Flag className="size-8" />}
              title="Stroke Play"
              description="Players are ranked by total strokes."
              selected={field.value === Clubhouse_LeagueScoring.STROKE}
              onClick={() => field.onChange(Clubhouse_LeagueScoring.STROKE)}
            />
            <OptionCard
              icon={<Swords className="size-8" />}
              title="Match Play"
              description="Players compete head-to-head in scheduled matches."
              selected={field.value === Clubhouse_LeagueScoring.MATCH}
              onClick={() => field.onChange(Clubhouse_LeagueScoring.MATCH)}
            />
            <OptionCard
              icon={<Trophy className="size-8" />}
              title="Points League"
              description="Players earn points based on flexible rules."
              selected={field.value === Clubhouse_LeagueScoring.POINTS}
              onClick={() => field.onChange(Clubhouse_LeagueScoring.POINTS)}
            />
          </div>
        )}
      />
      {errors.wizard?.leagueScoringType && (
        <p className={styles.wizardErrorCls}>
          {errors.wizard.leagueScoringType.message}
        </p>
      )}
    </div>
  );
}
